// src/shared/lib/gleap.ts

import Gleap from 'gleap';

const gleapAppId = import.meta.env.VITE_GLEAP_APP_ID;
const gleapEnv =
  (import.meta.env.VITE_GLEAP_ENV as 'dev' | 'staging' | 'prod') || 'dev';

// Gleap is disabled on dev (including local, where VITE_GLEAP_ENV defaults to 'dev').
export const isGleapEnabled = !!gleapAppId && gleapEnv !== 'dev';

export function initGleap() {
  if (!isGleapEnabled) return;
  Gleap.initialize(gleapAppId);
  Gleap.setEnvironment(gleapEnv);
  Gleap.setLanguage('en');
  Gleap.hideAiChatbar();
  Gleap.showFeedbackButton(false);
}

export function restartGleap() {
  if (!isGleapEnabled) return;
  Gleap.destroy();
  initGleap();
}
